import {useAppSelector} from "@Hooks/selector/useAppSelector";

/**
 * Returns passed key from form state
 * @see formSlice for keys
 */
export default function useForm(key: string) {
    return useAppSelector((state) => state?.form?.[key])
}